// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"JWvDjqRZ","image":"DRs5sg_9","title":"mO6zx3MD","button":"HyNe3X_d","appsWrapper":"_6RReFN_","appsWrapper__content":"zdCYhZ6Y","appsWrapper__title":"o62g9Uag"};